import { message } from 'antd';
import api from '../../api';
import { ndesActions } from './ndes';

// Fetch a list of NDEs
export const fetchNdes = (options) => async dispatch => {
  dispatch(ndesActions.ndesFetchStart());

  try {
    const result = await api.fetchNdes(options);

    if (result) {
      dispatch(ndesActions.ndesFetchComplete(result));
    } else {
      dispatch(ndesActions.ndesFetchFail('An error occured fetching NDEs. Please try again.'));
    }
  } catch (error) {
    const errorMessage = error.description || 'An error occured fetching NDEs. Please try again.';
    message.error(errorMessage);
    dispatch(ndesActions.ndesFetchFail(error));
  }
};

// Fetch a single NDE by ID
export const fetchNde = (ndeId, options) => async dispatch => {
  dispatch(ndesActions.ndeFetchStart());

  try {
    const result = await api.fetchNde(ndeId, options);

    if (result) {
      dispatch(ndesActions.ndeFetchComplete(result));
      return result;
    } else {
      dispatch(ndesActions.ndeFetchFail('An error occured fetching the NDE.'));
    }
  } catch (error) {
    //message.error('There was an error fetching the NDE.');
    dispatch(ndesActions.ndeFetchFail(error));
  }
};

// Fetch a single NDE by UUID
export const fetchNdeByUuid = (ndeUuid, options) => async dispatch => {
  dispatch(ndesActions.ndeFetchStart());

  try {
    const result = await api.fetchNdeByUuid(ndeUuid, options);

    if (result) {
      dispatch(ndesActions.ndeFetchComplete(result));
      return result;
    } else {
      dispatch(ndesActions.ndeFetchFail('An error occured fetching the NDE.'));
    }
  } catch (error) {
    //message.error('There was an error fetching the NDE.');
    dispatch(ndesActions.ndeFetchFail(error));
  }
};

// Create a new NDE
export const createNde = (values) => async (dispatch) => {
  dispatch(ndesActions.ndeCreateStart());

  try {
    const { recaptcha, ...payload } = values;

    const captchaResponse = await api.verifyRecaptcha(recaptcha);
    if (!captchaResponse) {
      dispatch(ndesActions.ndeFetchFail('Captcha could not be verified. Please try again.'));
      return false;
    }

    const createdNde = await api.createNde(payload);

    dispatch(ndesActions.ndeCreateComplete());
    return createdNde;
  } catch (error) {
    dispatch(ndesActions.ndeCreateFail(error));
    message.error('There was an error saving the NDE. Do not close the page, try again and if the issue persists contact an administrator.', 10);
    return false;
  }
};

// Update an existing NDE
export const updateNde = (ndeId, values) => async (dispatch) => {
  dispatch(ndesActions.ndeUpdateStart());

  try {
    await api.updateNde(ndeId, values);

    dispatch(ndesActions.ndeUpdateComplete());
    message.success('NDE updated!');

    return true;
  } catch (error) {
    dispatch(ndesActions.ndeUpdateFail(error));
    message.error('There was an error updating the NDE.');

    return false;
  }
};

// Delete a NDE
export const deleteNde = (ndeId) => async (dispatch) => {
  dispatch(ndesActions.ndeDeleteStart());

  try {
    await api.deleteNde(ndeId);

    dispatch(ndesActions.ndeDeleteComplete());
    message.success('NDE deleted!');

    return true;
  } catch (error) {
    dispatch(ndesActions.ndeDeleteFail(error));
    message.error('There was an error deleting the NDE.');

    return false;
  }
};

export const clearNdes = () => async (dispatch) => dispatch(ndesActions.ndesClearComplete());
